import { ChartAPIReturn, EventsConfig } from '@toggle/chart';
import { ChartInsight } from '@toggle/toggle';
import React, { FC, RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { useInsightsInDomain } from '../../hooks/use-insights-in-domain/useInsightsInDomain';
import { ChartInsightIcon } from './chart-insight-icon/ChartInsightIcon';
import * as S from './Insights.styles';

export interface InsightsProps {
  chartApiRef: RefObject<ChartAPIReturn | null>;
  canvasRef: RefObject<HTMLCanvasElement | null>;
  insights: ChartInsight[];
  eventsConfig: EventsConfig;
  isSimpleChart?: boolean;
}

export const Insights: FC<InsightsProps> = ({
  chartApiRef,
  canvasRef,
  insights,
  eventsConfig,
  isSimpleChart,
}) => {
  const { t } = useTranslation(['chart']);

  const { insightsInDomain, zoomIntoViewText } = useInsightsInDomain({
    canvasRef,
    eventsConfig,
    chartApiRef,
    insights,
  });

  return (
    <>
      {insightsInDomain.map((domainEntry, insightsInDomainIndex) => (
        <ChartInsightIcon
          key={insightsInDomainIndex}
          insightIconRight={domainEntry.right}
          insightIconTop={domainEntry.top}
          yOffsetCount={domainEntry.yOffsetCount}
          groupedInsights={domainEntry.groupedInsights}
          isSimpleChart={isSimpleChart}
        />
      ))}

      {zoomIntoViewText && (
        <S.ZoomIntoViewText
          data-testid="zoom-in-required"
          style={{
            top: zoomIntoViewText.y,
            right: zoomIntoViewText.right,
          }}
        >
          {t('chart:zoomInToView')}
        </S.ZoomIntoViewText>
      )}
    </>
  );
};
